import { render, staticRenderFns } from "./confirm-mail.vue?vue&type=template&id=fb2ca64c&"
import script from "./confirm-mail.vue?vue&type=script&lang=js&"
export * from "./confirm-mail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports